import React from 'react';
import { useRouteMatch } from 'react-router-dom';
import NavigationBar from './FigmaComponents/NavigationBar';
import './HubPage.scss';
import HubView from './HubView';

export default function HubPage({ noBack, rightAction, url }) {
  const { hub, page } = useRouteMatch()?.params;
  return (
    <div className="HubPage Content">
      {!noBack && <NavigationBar />}
      <div className="HubPage__right-action">{rightAction}</div>
      <HubView
        url={
          url ||
          `https://spclient.wg.spotify.com/hubview-mobile-v1/${
            hub === 'genre' ? 'browse' : hub
          }/${page}`
      }
      />
    </div>
  );
}
